class TreeProjectGallery extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-gallery-filter]')];
    this.items = [...this.querySelectorAll('[data-gallery-item]')];
    this.status = this.querySelector('[data-gallery-status]');

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.filter(button.dataset.galleryFilter));
    });
  }

  filter(value) {
    let visibleCount = 0;

    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.galleryFilter === value));
    });

    this.items.forEach((item) => {
      const visible = value === 'all' || item.dataset.galleryFinish === value;
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (this.status) {
      const selectedButton = this.buttons.find((button) => button.dataset.galleryFilter === value);
      const label = selectedButton?.textContent.trim() || 'selected';
      const selection = value === 'all' ? `all ${visibleCount}` : `${visibleCount} ${label}`;
      this.status.textContent = `Showing ${selection} project photo${visibleCount === 1 ? '' : 's'}.`;
    }
  }
}

if (!customElements.get('tree-project-gallery')) {
  customElements.define('tree-project-gallery', TreeProjectGallery);
}
